var _rect, _path, _rect2, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13,
    fill: "#201E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1193 11.6362H21.7343C20.891 11.6419 20.0904 11.2611 19.5561 10.6003L18.4414 9.0362C17.9159 8.36961 17.1153 7.98709 16.2733 8.00033H13.8803C9.58513 8.00033 8.00001 10.5589 8.00001 14.9095V19.6124C7.99467 20.1295 30.9981 20.1289 30.9996 19.6124V18.245C31.0201 13.8944 29.4758 11.6362 25.1193 11.6362Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.2928,
    width: 23.8635,
    height: 20.3281,
    rx: 6,
    fill: "#3077FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.781 22.8057C21.9023 22.4971 21.9687 22.1617 21.9687 21.8121C21.9687 21.0289 21.6363 20.3227 21.1066 19.8261C20.6153 19.3655 19.952 19.0829 19.224 19.0829C18.4044 19.0829 17.6675 19.4408 17.1648 20.0075C16.7388 20.4879 16.4793 21.1203 16.4793 21.8121C16.4793 22.5382 16.765 23.1984 17.2291 23.6865C17.7292 24.2126 18.4387 24.5412 19.224 24.5412C19.6312 24.5412 20.0191 24.4527 20.368 24.2934C21.0113 23.9998 21.5212 23.4661 21.781 22.8057Z",
    fill: "white",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2448,
    cy: 18.9283,
    r: 1.68354,
    fill: "#343843"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7848,
    cy: 16.6835,
    r: 1.68354,
    fill: "#343843"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3164,
    cy: 24.5401,
    r: 1.68354,
    fill: "#343843"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2109,
    cy: 27.5232,
    r: 1.12236,
    fill: "#343843"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9641,
    cy: 25.943,
    r: 1.96413,
    fill: "#343843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon2);
export default __webpack_public_path__ + "static/media/group_icon2.df35dcf74eae42e3d567500d888617ee.svg";
export { ForwardRef as ReactComponent };